import _, {Dictionary} from 'lodash';
import qs from 'qs';
import {ProductParameters, SearchQueryParameters} from './sharedInterfaces';

const DEFAULT_QS_STRINGIFY_OPTIONS: qs.IStringifyOptions = {
    arrayFormat: 'comma',
    encode: true,
    skipNulls: true,
};

const DEFAULT_QS_PARSE_OPTIONS: qs.IParseOptions = {
    ignoreQueryPrefix: true,
};

export const generateQueryString = (
    queryParams: any,
    options: qs.IStringifyOptions = DEFAULT_QS_STRINGIFY_OPTIONS
) => {
    return qs.stringify(queryParams, options);
};

export const parseQueryString = (
    queryString: string,
    options: qs.IParseOptions = DEFAULT_QS_PARSE_OPTIONS
) => {
    return qs.parse(queryString, options);
};

export const getSearchQueryParameters = (queryParams: Dictionary<any>) => {
    const params = _.pick(queryParams, [
        'page',
        'pageSize',
        'searchTerm',
        'sortCategory',
        'sortOrder',
    ]);

    return _.mapValues(params, (value, key) => {
        if (key === 'page' || key === 'pageSize') {
            return _.toNumber(value);
        }
        return value;
    }) as SearchQueryParameters;
};

export const getProductQueryParameters = (queryParams: Dictionary<any>): ProductParameters => {
    const params = _.pick(queryParams, [
        'brand',
        'classification',
        'effect',
        'flavor',
        'generalAttribute',
        'ingredient',
        'internalTag',
        'subtype',
        'type',
    ]);

    return _.mapValues(params, (value) => {
        return _.split(value, ',');
    }) as ProductParameters;
};
